import { InvoicePerMonthGrid } from "src/app/components";
import { useInvoicePerMonthList } from "src/app/hooks";

const InvoicePerMonthContainer = () => {
    const { invoicePerMonthList, loading } = useInvoicePerMonthList();

    return (
        <>
            {!loading && invoicePerMonthList.length > 0 && (
                <InvoicePerMonthGrid quotaPerYearList={invoicePerMonthList} />
            )}
        </>
    );
};

export default InvoicePerMonthContainer;
